import React, {useState} from 'react';
import styled from 'styled-components';
import heatmapTypes from './heatmapTypes';
import CanvasBox from './CanvasBox';
import List from './StyledComponents/CanvasBoxList';
import BankItem from './BankItem';
import theme from '../../../UI/theme';
import ColorMarker from './StyledComponents/ColorMarker';
import BlinkButton from '../../UiComponents/BlinkButton'
import { getZoneColor } from '../canvas/colorUtils';
import { postEvent } from '../../../scripts/event'

const ZoneContainer = styled.div`
    margin: 10px 0;
    padding: 10px 0;
`

const zoneName = styled.h4`
    margin: 0px;
`

const ZoneNameContainer = styled.div`
    display: flex;
    align-items: center;
`


const SensorBank = props => {

    const [blinkingSensors, setBlinkingSensors] = useState(props.sensors.map(s => ({...s , isBlinking: false})));

    var zoneGroups = [];
    props.zones.forEach(zone => {
        zoneGroups.push({
            ...zone,
            sensors: props.sensors.filter(sensor => sensor.zoneId === zone.floorElementId)
        })
    });

    const placeSensorHandler = (sensor) => {
        props.actionHandler(heatmapTypes.actions.PLACE_SENSOR, sensor);
    }

    const removeSensor = (sensor) => {
        props.actionHandler(heatmapTypes.actions.REMOVE_SENSOR, sensor);
    }

    const markSensor = (sensor) => {
        // unmark others
        props.actionHandler(heatmapTypes.actions.UNMARK_ALL_SENSORS, null);

        // mark selected if not already
        if (sensor.floorElementId != props.markedSensor) {
            props.actionHandler(heatmapTypes.actions.MARK_SENSOR, sensor);
            props.setMarkedSensor(sensor.floorElementId);
        } else {
            props.setMarkedSensor(null);
        }
    }

    const blinkSensor = (sensor) => {
        var updatedBlinkingSensors = [...blinkingSensors];
        updatedBlinkingSensors.forEach(s => {
            if(s.floorElementId == sensor.floorElementId) {
                var command;
                if (s.isBlinking) command = 'STOP_BLINK';
                else {
                    command = 'BLINK';
                    setTimeout(() => blinkingTimeout(sensor.floorElementId), 48*1000);
                }
                postEvent(sensor.hubId, props.customerId, command, {sensorId: sensor.floorElementId});
                s.isBlinking = !s.isBlinking;
            };
        });
        setBlinkingSensors(updatedBlinkingSensors);
    }

    const blinkingTimeout = (sensorId) => {
        var updatedBlinkingSensors = [...blinkingSensors];
        updatedBlinkingSensors.forEach(s => {if(s.floorElementId == sensorId) s.isBlinking = false;});
        setBlinkingSensors(updatedBlinkingSensors);
    }
    
    
    return <CanvasBox>
        <h4>Zone groups</h4>
        
            {zoneGroups.map(zone => {
                var zoneColor = getZoneColor(zone, props.zones);
                return <ZoneContainer key={zone.floorElementId}>
                        {zoneGroups.length > 1 ? <>
                            <ZoneNameContainer>
                                <ColorMarker color={zoneColor}/>
                                <zoneName>{zone.zoneName}</zoneName>
                            </ZoneNameContainer>
                        </> : <></>}                        
                        <List>
                        {zone.sensors.map((sensor) => {
                                return <BankItem 
                                            key={sensor.floorElementId} 
                                            item={sensor}
                                            displayName={getSensorName(sensor)} 
                                            placeItem={placeSensorHandler}
                                            removeItem={() => removeSensor(sensor)}
                                            isMarked={sensor.floorElementId === props.markedSensor}
                                            markItem={markSensor}
                                            floor={props.floors.find(floor => floor.floorId === sensor.floorId)}
                                            blinkButton={
                                                <BlinkButton
                                                    onClick={() => blinkSensor(sensor)}
                                                    isBlinking={blinkingSensors.find(s => s.floorElementId==sensor.floorElementId).isBlinking}
                                                />
                                            }
                                        />
                            })}
                        </List>
                    </ZoneContainer>
            })}
        
        
    </CanvasBox>
}

export default SensorBank;

function getSensorName(sensor) {
    var number = sensor.floorElementId.slice(sensor.floorElementId.length-3, sensor.floorElementId.length);
    if (sensor.ipAddress) {
        if (sensor.ipAddress.includes('.')) {
            var splitIP = sensor.ipAddress.split('.');
            var number = splitIP[splitIP.length - 1];
        }
    }
    return `Sensor ${number}`;
}